<template>
  <div class="mb-3 shadow-sm p-3 rounded-md h-28 flex">
    <img :src="bankImg" class="h-full rounded-md" />
    <div class="mx-3">
      <div class="text-black">{{ $t('payment.account_name') }} : {{ accountName }}</div>
      <div class="text-black">{{ $t('payment.account_number_label') }} : {{ accountNumber }}</div>
      <div>{{ $t('payment.bank') }} : {{ bankName }}</div>
      <div>{{ $t('payment.branch') }} : {{ accountBranch }}</div>
    </div>
  </div>
</template>

<script>
import { Banking } from "../classes";
export default {
  computed: {
    bankImg() {
      return require(`../assets/images/bank/${this.bankCode}.jpg`);
    },
    bankName() {
      return Banking.getBank(this.bankCode).name;
    },
  },
  props: {
    accountName: String,
    accountBranch: String,
    bankCode: String,
    accountName: String,
    accountNumber: String,
  },
};
</script>

<style></style>
